<template>
  <RouterView />
</template>

<style lang="scss">
@use 'assets/style/app.scss';

h1 {
  font-size: 2.7em;
  line-height: 2.7em;
  margin: 0 0 1em 0;
}

h2 {
  font-size: 2.1em;
  line-height: 2.1em;
  margin: 0 0 0.9em 0;
}

h3 {
  font-size: 1.8em;
  line-height: 1.8em;
  margin: 0 0 0.8em 0;
}

h4 {
  font-size: 1.5em;
  line-height: 1.5em;
  margin: 0 0 0.7em 0;
}

h5 {
  font-size: 1.2em;
  line-height: 1.2em;
  margin: 0 0 0.6em 0;
}

h6 {
  font-size: 1em;
  line-height: 1em;
  margin: 0 0 0.5em 0;
}

a {
  color: var(--q-primary);
}

button:not(.q-btn--outline):not(.q-btn--flat) {
  span.q-btn__content {
    color: var(--uni-text-on-primary);
  }
}
</style>
